export var QuiBasePalette;
(function (QuiBasePalette) {
    QuiBasePalette["Black"] = "black";
    QuiBasePalette["White"] = "white";
    QuiBasePalette["Blue"] = "blue";
    QuiBasePalette["Green"] = "green";
    QuiBasePalette["Orange"] = "orange";
    QuiBasePalette["Red"] = "red";
    QuiBasePalette["Purple"] = "purple";
    QuiBasePalette["Gold"] = "gold";
})(QuiBasePalette || (QuiBasePalette = {}));
export var QuiBrandPalette;
(function (QuiBrandPalette) {
    QuiBrandPalette["BrandBlack"] = "brand-black";
    QuiBrandPalette["BrandTeal"] = "brand-teal";
    QuiBrandPalette["BrandRoyal"] = "brand-royal";
    QuiBrandPalette["BrandPurple"] = "brand-purple";
    QuiBrandPalette["BrandOrange"] = "brand-orange";
})(QuiBrandPalette || (QuiBrandPalette = {}));
export var QuiSemanticPalette;
(function (QuiSemanticPalette) {
    QuiSemanticPalette["Active"] = "active";
    QuiSemanticPalette["Success"] = "success";
    QuiSemanticPalette["Warning"] = "warning";
    QuiSemanticPalette["Danger"] = "danger";
    QuiSemanticPalette["Queued"] = "queued";
})(QuiSemanticPalette || (QuiSemanticPalette = {}));
export const quiColorNumbers = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
